import { render, staticRenderFns } from "./SetStorageSpaceUpgrade.vue?vue&type=template&id=1bab97ba&scoped=true"
import script from "./SetStorageSpaceUpgrade.vue?vue&type=script&lang=js"
export * from "./SetStorageSpaceUpgrade.vue?vue&type=script&lang=js"
import style0 from "./SetStorageSpaceUpgrade.vue?vue&type=style&index=0&id=1bab97ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab97ba",
  null
  
)

export default component.exports